export default "__VITE_ASSET__2c4b6e1d__"